import { render, staticRenderFns } from "./InstanceServiceProfile.vue?vue&type=template&id=cdf6f088&"
import script from "./InstanceServiceProfile.vue?vue&type=script&lang=js&"
export * from "./InstanceServiceProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports